import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@material-ui/core';
import GridContainer from '../../../components/GridContainer';
import TextfieldWrapper from '../../../components/FormikWrappers/TextfieldWrapper';
import { addSafetyConfig, editSafetyConfig } from '../../../redux/actions/safety';
import { useDispatch } from 'react-redux';
import '../../Users/NewUser/newuser.scss';

const NewSafetyConfig = ({ open, handleClose, handleOk, config }) => {
  const formRef = useRef();
  const dispatch = useDispatch();
  const isEditMode = Boolean(config?.id);

  const validationSchema = Yup.object().shape({
    key: isEditMode ? Yup.string() : Yup.string().required('This is Required Field'),
    label: Yup.string().required('This is Required Field'),
    value: Yup.number().typeError('Value must be a number').required('This is Required Field')
  });

  const [initialFormState, setInitialFormState] = useState({
    key: '',
    label: '',
    value: ''
  });

  useEffect(() => {
    if (config?.id) {
      setInitialFormState({
        key: config.key || '',
        label: config.label || '',
        value: config.value || ''
      });
    }
  }, [config]);

  const submitForm = (values) => {
    if (config?.id) {
      dispatch(editSafetyConfig(config.id, values, handleOk));
    } else {
      dispatch(addSafetyConfig(values, handleOk));
    }
  };

  return (
    <Dialog maxWidth="md" fullWidth onClose={handleClose} open={open}>
      <DialogTitle>{config ? 'Update Safety Config' : 'New Safety Config'}</DialogTitle>
      <DialogContent dividers>
        <Formik
          innerRef={formRef}
          initialValues={{ ...initialFormState }}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={submitForm}
        >
          {() => (
            <Form>
              <GridContainer className="newuser__container">
                {!isEditMode && (
                  <Grid item xs={12}>
                    <TextfieldWrapper name="key" label="Key" placeholder="Key" />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <TextfieldWrapper name="label" label="Label" placeholder="Label" />
                </Grid>
                <Grid item xs={12}>
                  <TextfieldWrapper name="value" label="Value" placeholder="Value" type="number" />
                </Grid>
              </GridContainer>
            </Form>
          )}
        </Formik>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => formRef.current.submitForm()} color="primary">
          Save
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

NewSafetyConfig.propTypes = {
  config: PropTypes.object,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleOk: PropTypes.func
};

export default NewSafetyConfig;
